<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTestScriptIcon_24"
    viewBox="0 0 21 19"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M18.2 4.368h-1.962c.099-.26.162-.547.162-.842C16.4 2.128 15.194 1 13.7 1c-.945 0-1.764.455-2.25 1.137L11 2.7l-.45-.573A2.76 2.76 0 0 0 8.3 1C6.806 1 5.6 2.128 5.6 3.526c0 .295.063.581.162.842H3.8c-.999 0-1.791.75-1.791 1.685L2 15.316C2 16.25 2.801 17 3.8 17h14.4c.999 0 1.8-.75 1.8-1.684V6.053c0-.935-.801-1.685-1.8-1.685m-4.5-1.684c.495 0 .9.38.9.842 0 .463-.405.842-.9.842s-.9-.379-.9-.842.405-.842.9-.842m-5.4 0c.495 0 .9.38.9.842 0 .463-.405.842-.9.842s-.9-.379-.9-.842.405-.842.9-.842m9.9 12.632H3.8v-1.684h14.4zm0-4.21H3.8V6.052h4.572L6.5 8.436l1.458.985L10.1 6.693l.9-1.146.9 1.146 2.142 2.728 1.458-.985-1.872-2.383H18.2z"
    />
</svg>
